import { componentTypeAllowsAttachableType } from './componentCompatibility';
/**
 * A component type is a valid parent of the active type filter when ComponentCompatibility
 * lists one of the filtered types as its child (`compatibleChildTypeIds`).
 */
export function isCompatibleParentType(componentType, filteredTypeIds) {
    if (!componentType || filteredTypeIds.length === 0)
        return false;
    return componentType.compatibleChildTypeIds.some((childTypeId) => filteredTypeIds.includes(childTypeId));
}
/**
 * Building-level Components tab, with a type filter applied:
 * show every attachable the filtered type may live on, including ones with zero components.
 * Also keep an attachable that already holds a filtered component so that row stays draggable.
 * With no type filter, keep the populated-only list.
 */
export function visibleAttachablesForTypeFilter({ typeIds, buildingLevel, componentAttachables, parentComponentAttachables, componentTypes, filteredComponents }) {
    if (!buildingLevel || typeIds.length === 0)
        return componentAttachables;
    const selectedTypes = componentTypes.filter((type) => typeIds.includes(type.id));
    const populatedKeys = new Set(filteredComponents.map((component) => `${component.attachableType}-${component.attachableId}`));
    return parentComponentAttachables.filter((attachable) => {
        const key = `${attachable.attachableType}-${attachable.attachableId}`;
        const allowed = selectedTypes.some((type) => componentTypeAllowsAttachableType(type, attachable.attachableType));
        return allowed || populatedKeys.has(key);
    });
}
